import * as userSettings from './user-settings.js';
import moment from 'moment';

let savedFilterSettings = [];
let savedFilterTitle = '';
let savedFilterSection = null;
let savedFilterForm = null;
let savedFiltersSkip = [];
let afterApplySavedFilters = null;
let modalsInitiated = false;

// TODO: attempt to apply saved filters on the initially-generated page markup?

async function loadSavedFilters() {
	await ajax('loadSettings', { section: savedFilterTitle }, function({ settings }) {
		setSavedFilters(settings);
	});
}

function setSavedFilters(settings) {
	if (settings && _.isArray(settings)) {
		savedFilterSettings = settings;
	} else {
		savedFilterSettings = [];
	}

	activateLoadSettings();
}

async function init({
	section,
	form,
	title = null,
	callback = null,
	skip = [],
	savedSettings = null,
	lastSavedSettings = null
}) {
	if (!title) {
		title = location.pathname.split('/').slice(1, 3).join('-');
	}

	if (section instanceof jQuery) {
		section = section[0];
	}

	clearAfterApplySavedFilters();
	savedFilterModals();

	if (callback) {
		setAfterApplySavedFilters(callback);
	}

	savedFilterTitle = title;
	savedFilterSection = section;
	savedFilterForm = form;
	savedFiltersSkip = skip;

	const settings = lastSavedSettings === null ?
		(await userSettings.get(`saved_filters_${title}`))?.settings :
		await new Promise(resolve => setTimeout(() => resolve(lastSavedSettings), 50));

	applySavedFilters(form, settings);

	if (section.querySelector('.saved-filters-btn-reset')) {
		section.querySelector('.saved-filters-btn-reset').addEventListener('click', e => {
			e.preventDefault();
			e.stopImmediatePropagation();

			resetSavedFilters(form);
		});
	}

	form.setGlobalCallback('set', async () => {
		await saveCurrentState();
	});

	if(title && title == 'screen-seasonality' && $('[data-name=is_best_period] a')) {
		$('[data-name=is_best_period] a').on('click',selectBestPeriodSettings);
	}

	if (savedSettings !== null) {
		setSavedFilters(savedSettings);
	} else {
		await loadSavedFilters();
	}

	initFiltersToggle();

	await migrateLocalStorageSettings();
}

function selectBestPeriodSettings(e) {
	let isBestPeriod = savedFilterForm.get('is_best_period') == 0;
	let selectedsavedFilterSetting = false;

	for (const savedFilterSetting of savedFilterSettings) {
		if(savedFilterSetting.settings['is_best_period'] == 1 && isBestPeriod) {
			selectedsavedFilterSetting = savedFilterSetting;
			break;
		}
		else if(savedFilterSetting.settings['is_best_period'] == 0 && !isBestPeriod) {
			selectedsavedFilterSetting = savedFilterSetting;
			break;
		}
	}

	if($(".saved-filter-name").html() != "" && selectedsavedFilterSetting) {
		setFilterName(selectedsavedFilterSetting.title);
		let partialSettings = {... selectedsavedFilterSetting.settings };
		delete partialSettings.is_best_period;
		if(partialSettings.optionable == savedFilterForm.get('optionable')) {
			delete partialSettings.optionable;
		}
		setTimeout(() => { applySavedFilters(savedFilterForm, partialSettings); }, 100);
	}

}

function getCurrentState() {
	const data = savedFilterForm.data();
	const filtered = _.omit(data, savedFiltersSkip);

	return filtered;
}

async function saveCurrentState() {
	const data = getCurrentState();

	await userSettings.set(`saved_filters_${savedFilterTitle}`, data);
}

function initFiltersToggle() {
	const toggleButton = document.querySelector('.filters-toggle');

	if (toggleButton) {
		toggleButton.addEventListener('click', e => {
			e.preventDefault();
			toggleFiltersSidebar(toggleButton);
		});
	}
}

function resetSavedFilters(form) {
	form.reset();

	setFilterName(false);
	runAfterApplySavedFilters(form);
	saveCurrentState();
}

function populateSavedFiltersModal() {
	const modal = $('#saved-filters-load-modal');
	const list = modal.find('.list-group');

	list.empty();

	if (savedFilterSettings.length) {
		for (const i in savedFilterSettings) {
			list.append(
				'<a href="#" class="list-group-item flex flex-gap flex-align-center flex-justify-space-between" data-setting="' + i + '" data-title="' + savedFilterSettings[i].title + '" >' +
					savedFilterSettings[i].title +
					'<button type="button" class="btn btn-link btn-icon btn-xs text-red" data-group="' + i + '" >' +
						'<i class="icon fa-regular fa-xmark"></i>' +
					'</button>' +
				'</a>'
			);
		}
	} else {
		modal.modal('hide');
	}
}

function setFilterName(title) {
	if (!title) {
		console.log("UNSET SETTINGS TITLE")
		$(".saved-filter-name").html("");
	} else {
		console.log("SET SETTING TITLE",title)
		$(".saved-filter-name").html("Selected Filters:<br><span>"+title+"</span>");
	}
}

function savedFilterModals() {
	if (modalsInitiated) {
		return;
	}

	if (!$('#saved-filters-load-modal').length) {
		return;
	}

	modalsInitiated = true;

	console.log('initiating saved filter modals')

	$('#saved-filters-load-modal').on({
		'show.bs.modal': function() {
			populateSavedFiltersModal();
		}
	});

	$('#saved-filters-load-modal').on('click', '.list-group-item', function(e) {
		e.preventDefault();

		const { settings } = savedFilterSettings[ $(this).data('setting') ];

		setFilterName($(this).data('title'));
		applySavedFilters(savedFilterForm, settings);

		$('#saved-filters-load-modal').modal('hide');
	});

	$('#saved-filters-load-modal').on('click', '.list-group-item .btn', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		if (!confirm('Are you sure you wish to delete these saved settings?')) {
			return;
		}

		const set = savedFilterSettings[ $(this).closest('.list-group-item').data('setting') ];

		ajax('deleteSettings', { id: set.id }, function({ settings }) {
			setSavedFilters(settings);
			populateSavedFiltersModal();
		});
	});

	$('#saved-filters-save-modal').on({
		submit: function(e) {
			e.preventDefault();

			const data = $(this).find('form').serializeJSON();

			data.section = savedFilterTitle;
			data.settings = getCurrentState();

			$(this).find(':submit').prop('disabled', true).text('Saving...');

			ajax('saveSettings', data, ({ settings }) => {
				setSavedFilters(settings);
				setFilterName(data.title);
				$(this).modal('hide');
				$(this).find(':submit').prop('disabled', false).text('Save');
			});
		},
		'hidden.bs.modal': function() {
			$(this).find('form')[0].reset();
		},
		'show.bs.modal': function() {
			$(this).find('.modal-title').text('Save Settings');
		}
	});
}

function activateLoadSettings() {
	$('.saved-filters-btn-load').prop('disabled', savedFilterSettings.length === 0);
}

function applySavedFilters(form, data) {
	let hasChange = false;

	if (_.isObject(data)) {
		for (const key of Object.keys(data)) {
			if (savedFiltersSkip.includes(key)) {
				continue;
			}

			let updated;

			if (key === 'change' && form.has('gain_loss')) {
				updated = form.set('gain_loss', data[ key ], true);
			} else {
				updated = form.set(key, data[ key ], true);
			}

			if (updated) {
				hasChange = true;
			}
		}
	}

	if (hasChange) {
		runAfterApplySavedFilters(form);
	}
};

function setAfterApplySavedFilters(fn) {
	afterApplySavedFilters = fn;
};

function clearAfterApplySavedFilters() {
	afterApplySavedFilters = null;
};

function runAfterApplySavedFilters(form) {
	// console.log('after apply saved filters');
	if (typeof afterApplySavedFilters === 'function') {
		afterApplySavedFilters();
	} else {

	}
}

async function toggleFiltersSidebar(button, value = undefined) {
	const section = button.closest('.section');

	section.classList.toggle('section-hidden-sidebar', value);

	const hidden = section.classList.contains('section-hidden-sidebar');

	button.classList.toggle('active', !hidden);

	await userSettings.set('filters_hidden', hidden ? 1 : 0);
}

async function migrateLocalStorageSettings() {
	if (!localStorage) {
		return;
	}

	const keys = Object.keys(localStorage);
	const filtered = keys.filter(key => key.startsWith(savedFilterTitle));

	if (!filtered.length) {
		return;
	}

	const settings = {};

	for (const key of filtered) {
		const value = localStorage.getItem(key);
		const newKey = key.replace(`${savedFilterTitle}-`, '');

		settings[ newKey ] = value;
	}

	const data = {
		section: savedFilterTitle,
		settings,
		title: `Migrated settings ${moment().format('YYYY-MM-DD')}`,
	};

	console.log(`migrating saved settings ${savedFilterTitle}`, data);

	ajax('saveSettings', data, ({ settings }) => {
		setSavedFilters(settings);

		for (const key of filtered) {
			localStorage.removeItem(key);
		}
	});
}

const SavedFilters = {
	init,
	initFiltersToggle,
	loadSavedFilters,
	setSavedFilters,
	populateSavedFiltersModal,
	setFilterName,
	savedFilterModals,
	activateLoadSettings,
	applySavedFilters,
	setAfterApplySavedFilters,
	clearAfterApplySavedFilters,
	toggleFiltersSidebar,
};

export default SavedFilters;
